import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function HormonalStorm() {
  const hormones = [{
    name: 'El estrógeno cae',
    effect: 'Tu grasa se redistribuye hacia la cintura'
  }, {
    name: 'La progesterona baja',
    effect: 'La inflamación aumenta sin razón aparente'
  }, {
    name: 'La insulina pierde eficiencia',
    effect: 'Todo lo que comes se convierte en grasa más fácilmente'
  }, {
    name: 'El cortisol sube crónicamente',
    effect: 'El estrés te engorda literalmente'
  }, {
    name: 'La tiroides se ralentiza',
    effect: 'Tu metabolismo en reposo cae 15-20%'
  }];
  return <section className="w-full bg-lightGray py-16 px-4" data-id="element-166">
      <div className="max-w-[860px] mx-auto" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-168">
          <h2 className="text-[32px] font-bold text-dark mb-3" data-id="element-169">
            La 'Tormenta Metabólica Perfecta' de los 40+
          </h2>
          <p className="text-[17px] text-[#555]" data-id="element-170">
            A partir de los 38-42 años, CINCO hormonas cambian al mismo tiempo
            en el cuerpo femenino:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl shadow-lg border border-[#E0E0E0] overflow-hidden mb-10" data-id="element-171">
          <div className="grid grid-cols-1 md:grid-cols-2 bg-teal text-white font-bold uppercase text-[14px]" data-id="element-172">
            <div className="p-4 md:p-5 border-b md:border-b-0 md:border-r border-teal-dark" data-id="element-173">
              Lo que cambia
            </div>
            <div className="p-4 md:p-5" data-id="element-174">El efecto que sientes</div>
          </div>

          <div className="flex flex-col" data-id="element-175">
            {hormones.map((item, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-2 ${index % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'} ${index !== hormones.length - 1 ? 'border-b border-[#E0E0E0]' : ''}`} data-id="element-176">
                <div className="p-4 md:p-5 flex items-center gap-2 border-b md:border-b-0 md:border-r border-[#E0E0E0]" data-id="element-177">
                  <span className="font-bold text-dark" data-id="element-178">{item.name}</span>
                  <ArrowDown className="text-urgencyRed w-4 h-4" data-id="element-179" />
                </div>
                <div className="p-4 md:p-5 text-[15px] text-[#444] flex items-center" data-id="element-180">
                  {item.effect}
                </div>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-teal rounded-xl p-8 md:p-10 text-center shadow-xl" data-id="element-181">
          <div className="text-[64px] font-bold text-lime leading-none mb-2" data-id="element-182">
            88%
          </div>
          <p className="text-[18px] text-white font-medium mb-4 max-w-2xl mx-auto" data-id="element-183">
            de las mujeres hispanas mayores de 40 años tienen Resistencia a la
            Insulina sin saberlo
          </p>
          <p className="text-[13px] text-white/70" data-id="element-184">
            (Fuente: Instituto Nacional de Salud Pública México 2023 / CDC 2024)
          </p>
        </motion.div>
      </div>
    </section>;
}